export const visit = (vm, at) => {
at({ "it": { "conversations-visitor-experience-components": { "stagedAttachment": { "uploadProgress": "{{uploadedBytes}} di {{totalBytes}}" }, "fileSizeLimit": "Il file non pu\xF2 essere pi\xF9 grande di {{size}}" } } });
};